import { cn } from "@/lib/utils";
import { SKELETON_BASE_CLASS } from "@/common/skeleton.common";

interface SkeletonBoxProps {
  width?: string;
  height?: string;
  className?: string;
}

export function SkeletonBox({ 
  width, 
  height, 
  className 
}: SkeletonBoxProps) {
  return (
    <div 
      className={cn(
        SKELETON_BASE_CLASS,
        "rounded",
        width,
        height,
        className
      )}
      aria-hidden="true"
    />
  );
} 